import { getApiErrorMessage, normalizeError } from '@/core/api';

/** The unmet password-policy rules the server sends as `error.details.violations`. */
function getPasswordViolations(error: unknown): string[] {
  const details = normalizeError(error).details as { violations?: unknown } | undefined;
  const violations = details?.violations;
  return Array.isArray(violations)
    ? violations.filter((v): v is string => typeof v === 'string' && v.trim() !== '')
    : [];
}

interface PasswordErrorMessageProps {
  error: unknown;
  fallback?: string;
}

/**
 * Error copy for a password form. The policy headline alone doesn't tell the
 * user what to change, so the unmet rules are listed when the server sends them.
 */
export function PasswordErrorMessage({ error, fallback }: PasswordErrorMessageProps) {
  const violations = getPasswordViolations(error);
  if (violations.length === 0) return <>{getApiErrorMessage(error, fallback)}</>;

  return (
    <>
      <span className="block">Your password doesn&apos;t meet these requirements:</span>
      <ul className="mt-1 list-disc space-y-0.5 pl-5">
        {violations.map((rule) => (
          <li key={rule}>{rule}</li>
        ))}
      </ul>
    </>
  );
}
